import React from 'react';
import { Headline } from 'mesh-component-library';

export type Props = {
    headerText: string;
};

const MeshHeader: React.FC<Props> = ({ headerText }) => {
    return (
        <Headline
            title={
                <div className="mesh-header-content" data-testid="mesh-header-content">
                    {headerText}
                </div>
            }
        />
    );
};

export default MeshHeader;
